<template>
  <a-drawer width="60%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-page-header title="定位信息" sub-title="Positioning Information">
        <a-row v-if="form" style="display: flex;width: 100%;height:500px">
          <a-col :span="24">
            <DeviceMap ref="mapRef" @mapInfo="handleMapInfo"/>
          </a-col>
        </a-row>
        <a-row style="display: flex;width: 100%">
          <a-col :span="11">
            <a-form-model-item label="经度" prop="deviceLongitude">
              <a-input-number v-model="form.deviceLongitude" style="width: 200px;" placeholder="经度" />
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item label="纬度" prop="deviceLatitude">
              <a-input-number v-model="form.deviceLatitude" style="width: 200px;" placeholder="纬度" />
              <a-button type="primary" style="margin-left: 10px;" @click="positioning()">定位</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="display: flex;width: 100%">
          <a-col :span="11">
            <a-form-model-item label="城市名称" prop="city">
              <a-input v-model="form.city" disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
          <a-col :span="2"></a-col>
          <a-col :span="11">
            <a-form-model-item label="定位地址" prop="formattedAddress">
              <a-input v-model="form.formattedAddress" disabled="disabled"></a-input>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-page-header>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm"> 保存 </a-button>
          <a-button type="dashed" @click="cancel"> 取消 </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getPositioningInfo, editPositioningObj, getDevice } from '@/api/saifuneng/device'
import DeviceMap from '@/components/MAP/deviceIndex'
export default {
  name: 'PositioningForm',
  props: {},
  components: {
    DeviceMap
  },

  data() {
    return {
      submitLoading: false,
      formTitle: '',
      // 日期范围
      timeRange: [],
      // 表单参数
      form: {
        id: null,
        deviceLongitude: null,
        deviceLatitude: null,
        country: null,
        province: null,
        city: null,
        citycode: null,
        district: null,
        adcode: null,
        township: null,
        towncode: null,
        formattedAddress: null
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {
        deviceLongitude: [
          { required: true, message: '请输入经度', trigger: 'blur' }
        ],
        deviceLatitude: [
          { required: true, message: '请输入纬度', trigger: 'blur' }
        ]
      }
    }
  },
  filters: {},
  created() {

  },
  computed: {},
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        deviceId: null,
        determineStartTime: null,
        determineEndTime: null,
        determinePercentage: null
      }
      this.$nextTick(() => {
        this.$refs.form.resetFields()
      })
    },
    /** 新增按钮操作 */
    handleAdd(id) {
      this.reset()
      if (id) this.form.id = id
      getDevice({ id: id }).then((res) => {
        // this.form = res.data
        const formData = {
          deviceLongitude: res.data.deviceLongitude,
          deviceLatitude: res.data.deviceLatitude,
          country: res.data.country,
          province: res.data.province,
          city: res.data.city,
          citycode: res.data.citycode,
          district: res.data.district,
          adcode: res.data.adcode,
          township: res.data.township,
          towncode: res.data.towncode,
          formattedAddress: res.data.formattedAddress
        }
        this.form = { ...formData }
        this.$refs.mapRef.init(formData)
        this.form.id = id
      })
      this.formType = 1
      this.open = true
      this.formTitle = '修改定位'
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      editPositioningObj({ id: id }).then((response) => {
        this.form.deviceId = response.data.deviceId
        this.open = true
        this.formTitle = '修改定位'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          editPositioningObj({ ...this.form })
            .then((response) => {
              this.$message.success('修改成功', 3)
              this.open = false
              this.$emit('ok')
            })
            .finally(() => {
              this.submitLoading = false
            })
        } else {
          return false
        }
      })
    },
    handleMapInfo(info) {
      this.form.deviceLongitude = info.lng
      this.form.deviceLatitude = info.lat
      this.form.city = info.addressComponent.city
      this.form.formattedAddress = info.detailedAddress
    },
    // 定位
    positioning() {
      const deviceLongitude = this.form.deviceLongitude
      const deviceLatitude = this.form.deviceLatitude
      this.$refs.form.validate((valid) => {
        if (valid) {
          getPositioningInfo({ deviceLongitude: deviceLongitude, deviceLatitude: deviceLatitude }).then((response) => {
            this.form.country = response.data.addressComponent.country
            this.form.province = response.data.addressComponent.province
            this.form.city = response.data.addressComponent.city ? response.data.addressComponent.city[0] : ''
            this.form.citycode = response.data.addressComponent.citycode
            this.form.district = response.data.addressComponent.district
            this.form.adcode = response.data.addressComponent.adcode
            this.form.township = response.data.addressComponent.township
            this.form.towncode = response.data.addressComponent.towncode
            this.form.formattedAddress = response.data.formatted_address
          })
        } else {
          return false
        }
      })
    }
  }
}
</script>
<style lang="less" scoped>
.ant-page-header {
  display: block !important;
}

.customUser_id {
  display: flex;
  align-items: center;

  .customUser_t {
    font-size: 20px;
    margin-left: 20px;
    cursor: pointer;
  }
}
</style>
